import React, { useEffect } from "react";

import { useRequest } from "ahooks";
import { api } from "@/redux/api";
import Select from "@components/ResponsiveSelect";

const fetchUsers = (search) => {
  return api.filterCustomUsers(search).then((res) => {
    const results = res?.data?.results ?? [];
    return results.map((item) => {
      return {
        value: item.id,
        label: item.username,
      };
    });
  });
};

export const UserSelect = (props) => {
  const { value } = props;

  const {
    data: users = [],
    run: searchUsers,
    loading,
  } = useRequest(fetchUsers, {
    debounceWait: 300,
    manual: true,
  });

  useEffect(() => {
    searchUsers();
  }, []);

  useEffect(() => {
    if (Array.isArray(value)) {
      if (value.length) {
        searchUsers();
      }
    } else if (value) {
      searchUsers(`id=${value}`);
    }
  }, [value]);

  const handleSearch = (inputValue) => {
    if (!inputValue) {
      searchUsers();
      return;
    }
    searchUsers(`username=${inputValue}`);
  };

  return (
    <Select
      {...props}
      loading={loading}
      showSearch
      allowClear
      options={users}
      filterOption={false}
      onSearch={handleSearch}
      defaultActiveFirstOption={false}
      notFoundContent={null}
    />
  );
};
